





















































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import addTaskMixin from './addTaskMixin'

@Component({})
export default class Settle extends Mixins(addTaskMixin) {
	public taskType: any = '6'
}
